export default {
    "searchjoborcompany": "Search Job or Company",
    "searchcitycounty": "Search City,County",
    "choosesector": "Choose Sector",

}